import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import Dropdown, { DropdownProps } from '@ui/Dropdown';
import { cx } from 'class-variance-authority';
import { Key } from 'react';
import { useTranslation } from 'react-i18next';

export interface Option {
    label: string;
    value: Key;
    icon?: IconDefinition;
}

interface Props {
    options: Option[];
    buttonProps?: Partial<DropdownProps>;
    onChange?: (option: Option['value']) => any;
    value?: Option['value'] | Option['value'][];
    disabled?: boolean;
}

export const SelectComponent = ({ disabled, options, buttonProps, value, onChange = () => {} }: Props) => {
    const { t } = useTranslation('form');
    const {
        className,
        containerClassName,
        label: customLabel,
        block,
        flat,
        color,
        disabled: buttonDisabled,
        isDisabled: buttonIsDisabled,
        ...restButtonProps
    } = buttonProps || {};

    const selectedValue = Array.isArray(value) ? value?.[0] : value;
    const selectedOption = options?.find((opt) => opt.value == selectedValue);
    const placeholderLabel = customLabel ?? t('select.placeholder');
    const dropdownLabel = selectedOption?.label ?? placeholderLabel;
    const isDropdownDisabled = Boolean(disabled || buttonDisabled || buttonIsDisabled);

    return (
        <Dropdown
            size="sm"
            block={block ?? true}
            flat={flat ?? true}
            color={color ?? 'light'}
            label={dropdownLabel}
            {...restButtonProps}
            disabled={isDropdownDisabled}
            isDisabled={isDropdownDisabled}
            className={cx('tw-w-full tw-justify-between tw-gap-2 tw-text-center', className)}
            containerClassName={cx('tw-w-full', containerClassName)}
        >
            {options?.map((item) => (
                <Dropdown.Item key={item.value} label={item.label} onClick={() => onChange(item.value)} />
            ))}
        </Dropdown>
    );
};

export default SelectComponent;
